import * as types from './showSeasonActionTypes';

export default (
  state = {
    season: {},
    applicants: 1,
    error: null,
    loading: false,
  },
  action
) => {
  switch (action.type) {
    case types.GET_SHOW_SEASON_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.GET_SHOW_SEASON_SUCCESS:
      return {
        ...state,
        loading: false,
        season: action.season,
      };
    case types.GET_SHOW_SEASON_ERROR:
      return {
        ...state,
        season: {},
        loading: false,
        error: action.error,
      };
    case types.SET_SHOW_APPLICANTS:
      return { ...state, applicants: action.applicants}
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/showSeason/showSeasonReducer.js